import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import DrawerModal from '../../shared/DrawerModal';
import styles from './AreaNoteModal.styles';
import {
  closeModal,
  getIsVisibleModal,
} from '../../../redux/store/ui/common/index';
import {
  updateArea,
  selectSelectedArea,
} from '../../../redux/store/appData/areas';
import { useIntl } from 'react-intl';
import Editor from './Editor';
import TurndownService from 'turndown';

const AreaNoteModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const visibleModal = useSelector(getIsVisibleModal('AreaNoteModal'));
  const selectedArea = useSelector(selectSelectedArea);

  const quillRef = useRef(null);

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();

    const turndownService = new TurndownService();
    const note = quillRef.current?.root.innerHTML || '';
    const noteMarkdown = turndownService.turndown(note);

    dispatch(updateArea(selectedArea?.id, { note: noteMarkdown }));
    dispatch(closeModal('AreaNoteModal'));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('AreaNoteModal'));
  };

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('ArchiveAreaModal'));
        }}
      >
        <div className="area-note-modal">
          <div className="area-note-modal-wrapper">
            <div className="area-note-modal-inputs">
              <p className="area-note-title">
                {intl.formatMessage({
                  id: `fleetadmin.area.edit.note`,
                })}
              </p>
            </div>
            <Editor ref={quillRef} />
          </div>
          <Button className="submit-button" onClick={handleOnSubmit}>
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default AreaNoteModal;
